export const trackedChangeCommentsKeys = {
  prefix: 'trackedChangeComments',
  list: (trackedChangeId: string) => [trackedChangeCommentsKeys.prefix, trackedChangeId, 'list'],
  detail: (trackedChangeId: string, id: string) => [...trackedChangeCommentsKeys.list(trackedChangeId), 'detail', id],
  create: (trackedChangeId: string) => [...trackedChangeCommentsKeys.list(trackedChangeId), 'create'],
  update: (trackedChangeId: string, id: string) => [...trackedChangeCommentsKeys.detail(trackedChangeId, id), 'update'],
  delete: (trackedChangeId: string, id: string) => [...trackedChangeCommentsKeys.detail(trackedChangeId, id), 'delete'],
  toggleReaction: (trackedChangeId: string, id: string) => [
    ...trackedChangeCommentsKeys.detail(trackedChangeId, id),
    'toggleReaction',
  ],
}
